import api, { APIResponse, getAxiosRequestConfig } from "../../config/api";
import { Dispatch } from "redux";
import { GetState } from "../store";
import { ActiveTypes } from "./brandActions";

export interface outletDetails {
  outletcode?: string;
  country?: string;
  region?: string;
  state?: string;
  city?: string;
  area?: string;
}

export interface outletType {
  id?: number;
  portfolioid: number;
  brandid: number;
  brandcompanyid: number;
  countryid: number;
  regionid: number;
  stateid: number;
  cityid: number;
  area: string;
  address1: string;
  address2: string;
  pincode: string;
  active: ActiveTypes | boolean;
  franchise: boolean;
  outletcode: string;
  outlettype: number;
  outletlocation: number;
  carpetarea: number;
  chargeablearea: number;
  tradecatid: number;
  tradesubcatid: number;
  leaseid: string;
  centerid?: number;
  renttype: number;
  revenueshare: string;
  fromdate: string;
  todate: string;
}

export enum OutletActionsList {
  ADD_OUTLET_MANAGER = "ADD_OUTLET_MANAGER",
  EDIT_OUTLET_MANAGER = "EDIT_OUTLET_MANAGER",
  FETCH_OUTLET_MANAGER = "FETCH_OUTLET_MANAGER",
  FETCH_USER_OUTLET_MANAGER = "FETCH_USER_OUTLET_MANAGER",
  DELETE_OUTLET_MANAGER = "DELETE_OUTLET_MANAGER",
  CLEAR_OUTLET_MANAGER = "CLEAR_OUTLET_MANAGER",
  FETCH_CENTER_OUTLET_MANAGER = "FETCH_CENTER_OUTLET_MANAGER",
}

export interface DELETE_OUTLET_MANAGER {
  id: number;
}

export interface AddOutletAction {
  type: OutletActionsList.ADD_OUTLET_MANAGER;
  data: outletType;
}

export interface EditOutletAction {
  type: OutletActionsList.EDIT_OUTLET_MANAGER;
  data: outletType;
  id?: number;
}

export interface DeleteOutletAction {
  type: OutletActionsList.DELETE_OUTLET_MANAGER;
  data: DELETE_OUTLET_MANAGER;
}

export interface FetchOutletAction {
  type: OutletActionsList.FETCH_OUTLET_MANAGER;
  data: outletType[];
}

export interface FetchUserOutletAction {
  type: OutletActionsList.FETCH_USER_OUTLET_MANAGER;
  data: outletType[];
}

export interface FetchCenterOutletAction {
  type: OutletActionsList.FETCH_CENTER_OUTLET_MANAGER;
  data: outletType[];
}

export interface ClearOutletAction {
  type: OutletActionsList.CLEAR_OUTLET_MANAGER;
}

export type OutletActions =
  | AddOutletAction
  | EditOutletAction
  | DeleteOutletAction
  | ClearOutletAction
  | FetchOutletAction
  | FetchUserOutletAction
  | FetchCenterOutletAction;

export const fetchOutlet = (portfolioId: string, id: number) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    const token = getState().authUser?.["auth-token"]!;
    const config = getAxiosRequestConfig(token);

    return api
      .get<APIResponse<outletType[]>>(`outlet/${portfolioId}/${id}`, config)
      .then((response) => {
        if (response.status === 200 && response.data.data) {
          dispatch<FetchOutletAction>({
            type: OutletActionsList.FETCH_OUTLET_MANAGER,
            data: response.data.data,
          });
          return Promise.resolve(
            response.data.message ? response.data.message : "Fetch Successfull"
          );
        } else {
          // throw { response };
          throw new Error("Unable to fetch")
        }
      })
      .catch((error) => {
        return Promise.reject(
          error.response
            ? error.response.data.message
              ? error.response.data.message
              : "Unable to fetch"
            : "Unable to fetch"
        );
      });
  };
};

export const fetchCenterOutlet = (portfolioId: string, siteid: string) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    const token = getState().authUser?.["auth-token"]!;
    const config = getAxiosRequestConfig(token);

    return api
      .get<APIResponse<outletType[]>>(`outlet-center/${portfolioId}/${siteid}`, config)
      .then((response) => {
        if (response.status === 200 && response.data.data) {
          dispatch<FetchCenterOutletAction>({
            type: OutletActionsList.FETCH_CENTER_OUTLET_MANAGER,
            data: response.data.data,
          });
          return Promise.resolve(
            response.data.message ? response.data.message : "Fetch Successfull"
          );
        } else {
          throw new Error("Unable to fetch")
        }
      })
      .catch((error) => {
        return Promise.reject(
          error.response
            ? error.response.data.message
              ? error.response.data.message
              : "Unable to fetch"
            : "Unable to fetch"
        );
      });
  };
};

export const fetchUserOutlet = (
  portfolioId: string,
  bcid: number,
  id: number
) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    const token = getState().authUser?.["auth-token"]!;
    const config = getAxiosRequestConfig(token);

    return api
      .get<APIResponse<outletType[]>>(
        `outlet/${portfolioId}/${bcid}/${id}`,
        config
      )
      .then((response) => {
        if (response.status === 200 && response.data.data) {
          dispatch<FetchOutletAction>({
            type: OutletActionsList.FETCH_OUTLET_MANAGER,
            data: response.data.data,
          });
          return Promise.resolve(
            response.data.message ? response.data.message : "Fetch Successfull"
          );
        } else {
          throw new Error("Unable to fetch")
        }
      })
      .catch((error) => {
        return Promise.reject(
          error.response
            ? error.response.data.message
              ? error.response.data.message
              : "Unable to fetch"
            : "Unable to fetch"
        );
      });
  };
};

export const clearOutlet = () => {
  return async (dispatch: Dispatch, getState: GetState) => {
    return dispatch<ClearOutletAction>({
      type: OutletActionsList.CLEAR_OUTLET_MANAGER,
    });
  };
};
